import {
  ELEMENT_OL,
  ELEMENT_UL,
  MyBulletedListElement,
  MyBulletedListElementActual,
  MyNumberedListElement,
} from 'lib-knowledge-document-structure/plateTypes';

export function convertUlToOl(
  element: MyBulletedListElement | MyBulletedListElementActual,
): MyNumberedListElement {
  const actualElement = element as MyBulletedListElementActual;
  return {
    id: actualElement.id,
    type: ELEMENT_OL,
    // eslint-disable-next-line
    // @ts-ignore
    children: actualElement.children.map((c) => {
      // c.type is 'li'
      return {
        ...c,
        children: c.children.map((subChild) => {
          if (subChild.type === ELEMENT_UL) {
            // eslint-disable-next-line
            // @ts-ignore
            return convertUlToOl(subChild);
          }
          return subChild;
        }),
      };
    }),
  };
}
